export const SET_AGREE_TO_ALL = 'SET_AGREE_TO_ALL';
export const SET_REJECT_ALL = 'SET_REJECT_ALL';
export const UPDATE_COOKIE_STATUS = 'UPDATE_COOKIE_STATUS';
export const SET_HAS_SAVED_COOKIE_SETTINGS = 'SET_HAS_SAVED_COOKIE_SETTINGS';
export const MIGRATE_COOKIE_DASHBOARD = 'MIGRATE_COOKIE_DASHBOARD';
